import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import type { PaymentPlanStatus } from '../../../types/payment';

const STATUS_MAP: Record<
  PaymentPlanStatus,
  'positive' | 'helper' | 'negative' | 'default' | 'highlight'
> = {
  active: 'positive',
  completed: 'highlight',
  cancelled: 'negative',
  overdue: 'helper',
  inactive: 'default',
};

interface PaymentStatusBadgeProps {
  readonly status: PaymentPlanStatus;
}

export function PaymentStatusBadge({ status }: PaymentStatusBadgeProps) {
  const { t } = useTranslation('personManagement');
  return (
    <Tag
      label={t(`status.${status}`)}
      size="md"
      status={STATUS_MAP[status] ?? 'default'}
      custom={{ text: 'text-nowrap' }}
    />
  );
}
